import React, { ReactElement, useState } from 'react';
import { DropdownMenuItem, TopBar } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { AppearanceContext, AppearanceThemes } from '@erecruit/modules';
import { EditModeElementWrapper } from './EditModeContextProvider';

import { ScreenOverlay } from '../helpers';

import { NotificationStand } from '../../components/Notifications';
import { ProblemReport } from '../../components/ProblemReport';
import logoSrc from '../../logo.png';
import logoWhiteSrc from '../../logoWhite.png';
import SearchComponent from './SearchComponent';
import { useAppConfig } from '../../appConfig';

const { FormattedMessage } = Intl;

interface HeaderProps {
  userName: string;
  onLogout: Function;
  onSettingsClick: Function;
}

const Header = ({
  userName,
  onLogout,
  onSettingsClick,
}: HeaderProps): ReactElement => {
  const [overlayVisible, setOverlayVisible] = useState(false);
  const appConfig = useAppConfig();

  const settings: DropdownMenuItem[] = [
    {
      icon: 'settings',
      text: <FormattedMessage id={messageIds.vms.menu.settings} />,
      onClick: (): void => {
        onSettingsClick();
      },
    },
    {
      icon: 'logout',
      text: <FormattedMessage id={messageIds.vms.menu.logout} />,
      onClick: (): void => {
        onLogout();
      },
    },
  ];

  return (
    <>
      {overlayVisible ? <ScreenOverlay /> : null}
      <EditModeElementWrapper>
        <AppearanceContext.Consumer>
          {({ appearance }) => (
            <TopBar
              userName={userName}
              problemReport={<ProblemReport />}
              notifications={<NotificationStand />}
              logo={{
                link: '/',
                source:
                  appearance?.theme === AppearanceThemes.Dark
                    ? logoWhiteSrc
                    : logoSrc,
              }}
              searchComponent={
                appConfig?.REACT_APP_DISABLE_QUICK_SEARCH ? (
                  undefined
                ) : (
                  <SearchComponent setOverlayVisible={setOverlayVisible} />
                )
              }
              settings={settings}
            />
          )}
        </AppearanceContext.Consumer>
      </EditModeElementWrapper>
    </>
  );
};

export default Header;
